// This file is automatically compiled by Vite, along with any other files
// present in this directory.
import 'lib/findDOMNodeShim';
// Labels for the current locale load as a separate entry ahead of this pack
// (ApplicationHelper#locale_js_tags), so only one locale ships per page.
import 'lib/I18n';
import requireContextFromGlob from 'lib/requireContextFromGlob';
import ReactRailsUJS from 'react_ujs';

// ReactRails automatically loads `app/frontend/components`, it must expose
// react_ujs as `ReactRailsUJS` and prepare a require context.

// idea: exclude admin, onboarding, and landing packs
const loadComponents = () =>
  requireContextFromGlob(
    import.meta.glob('../components/**/*.{js,jsx}', { eager: true }),
    '../components/'
  );
ReactRailsUJS.useContext(loadComponents());

// Hot Module Replacement (HMR) support
// This allows React components to be hot-swapped without full page reloads.
// We use a manual unmount/remount approach rather than React Refresh because
// ReactRailsUJS mounts components independently via its own createRoot-backed
// roots, which is incompatible with React Refresh's automatic state preservation.
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    ReactRailsUJS.useContext(loadComponents());
    ReactRailsUJS.unmountComponents();
    ReactRailsUJS.mountComponents();
  });
}
